import PropTypes from "prop-types";
import React from "react";
import { UrlUtils } from "../../utils";
import { useCommunicationHandlers } from "../UsefulLinks";
import { SVGIcon2 } from "../../components/common/SVGIconV2";
import { AppFeatures } from "../../constants/featureFlags";
import { BrandUtils } from "../../utils/brandUtils";
import { useFeature } from "../../hooks/useFeature";
import { TrackingInfo } from "../../components/tracking/TrackingInfoHeader";

export const HeaderLinksPC = props => {
  const { helpLink } = props;
  const { handleOnlineHelp, handleHelpCenter } = useCommunicationHandlers();
  const isHelpWidgetActive = useFeature(AppFeatures.HELP_WIDGET);
  const helpWidgetConditions = isHelpWidgetActive || BrandUtils.isPokerClient();
  const isCustomerRelationsActive = useFeature(AppFeatures.CUSTOMER_RELATIONS);

  return (
    <div className="headerLinks">
      <a
        className="aChelpLink circleIcon"
        href={
          helpWidgetConditions || isCustomerRelationsActive
            ? undefined
            : UrlUtils.getNativeLink(helpLink)
        }
        onClick={
          helpWidgetConditions
            ? handleHelpCenter
            : isCustomerRelationsActive
              ? handleOnlineHelp
              : undefined
        }
        target="OnlineHelpTab"
        data-testid="uc-header-help-link"
        data-category={TrackingInfo.dataCategory}
        data-action={TrackingInfo.dataAction}
        data-label="Help"
        data-value=""
      >
        <SVGIcon2 iconName="help" />
      </a>
    </div>
  );
};

HeaderLinksPC.propTypes = {
  helpLink: PropTypes.string
};
